import { Component, Input, HostListener, ElementRef } from '@angular/core';
import { RecentRoute } from '../../models/RecentRoutes';

@Component({
  selector: 'app-recent-routes-display',
  templateUrl: './recent-routes-display.component.html',
  styleUrls: ['./recent-routes-display.component.scss'],
})
export class RecentRoutesDisplayComponent {
  toggleShow = false;
  showMore = false;
  @Input() recents: RecentRoute[] = [];
  @Input() inHeader = false;

  constructor(private eRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.inHeader && !this.eRef.nativeElement.contains(event.target)) {
      this.toggleShow = false;
    }
  }
}
